import axios, { AxiosInstance } from 'axios';
import { AuditEventsResponse, GetAuditEventsParams, AuditEventTypeConfig } from 'types/apis/audit';
import { RunContextApp } from 'framework/RCApp';

class AuditApiClient {
  private axiosClient: AxiosInstance;
  constructor(private rc: RunContextApp, private baseUrl: string) {
    this.axiosClient = axios.create();
    this.axiosClient.interceptors.request.use((config) => {
      const token = this.rc.session.getCMSAccessToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  }

  async getProjectAuditEvents(params: GetAuditEventsParams): Promise<AuditEventsResponse> {
    const resp = await this.axiosClient.get(`${this.baseUrl}/v1/audit/project-activity`, { params });
    return resp.data;
  }

  async getUserAuditEvents(params: GetAuditEventsParams): Promise<AuditEventsResponse> {
    const resp = await this.axiosClient.get(`${this.baseUrl}/v1/audit/user-activity`, { params });
    return resp.data;
  }

  async getAuditEventTypes(params: { project_id: string; source_names?: string }): Promise<AuditEventTypeConfig[]> {
    const resp = await this.axiosClient.get(`${this.baseUrl}/v1/audit/event-types`, { params });
    return resp.data;
  }

  async getAuditSources(params: { project_id: string }): Promise<string[]> {
    const resp = await this.axiosClient.get(`${this.baseUrl}/v1/audit/sources`, { params });
    return resp.data;
  }
}

export function createAuditApiClient(rc: RunContextApp, baseUrl: string) {
  return new AuditApiClient(rc, baseUrl);
}
